
import React from "react";
import { TypingEffect } from "@/components/bot-builder/TypingEffect";
import { StepCard } from "@/components/bot-builder/StepCard";
import { BotPreviewCard } from "@/components/bot-builder/BotPreviewCard";
import { DevelopmentBanner } from "@/components/bot-builder/DevelopmentBanner";
import { Bot, LineChart, Target } from "lucide-react";
import { useTranslation } from "react-i18next";

const CommunityPage = () => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto py-8 space-y-16 max-w-6xl">
      <div className="text-center space-y-6">
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
          {t('build_your_bot_title')} 🤖
        </h1>
        <p className="text-xl md:text-2xl font-medium text-muted-foreground">
          {t('build_your_bot_subtitle')}
        </p>
        <div className="max-w-2xl mx-auto">
          <TypingEffect text={t('build_your_bot_typing')} className="text-lg text-muted-foreground" />
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        <StepCard 
          step={1} 
          icon={Bot} 
          title={t('step_choose_style_title')} 
          description={t('step_choose_style_desc')} 
        />
        <StepCard 
          step={2} 
          icon={LineChart} 
          title={t('step_select_market_title')} 
          description={t('step_select_market_desc')} 
        />
        <StepCard 
          step={3} 
          icon={Target} 
          title={t('step_set_goals_title')} 
          description={t('step_set_goals_desc')} 
        />
      </div>

      <div className="space-y-8">
        <div className="text-center">
          <h2 className="text-2xl font-semibold mb-2">{t('preview_bot_title')}</h2>
          <p className="text-muted-foreground">
            {t('preview_bot_subtitle')}
          </p>
        </div>
        <div className="flex justify-center">
          <BotPreviewCard />
        </div>
      </div>

      <div className="max-w-2xl mx-auto">
        <DevelopmentBanner />
      </div>
    </div>
  );
};

export default CommunityPage;
